export default {
      id: "ic-nav-traduction-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-nav-traduction-usage",
      toString: function () {
        return this.url;
      }
    }